import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import TableAdvertising from 'views/betShopManagement/cashier/tableAdvertising'; // Importing TableAdvertising component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the advertising view for the bet shop.
 * @extends JetView
 */
export default class betShopAdvertisingView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size
                },
            ],
        };

        // Left panel configuration
        const left = {
            responsiveCell: false,
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for collapsible sections
                    css: 'betShop',
                    collapsed: false,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            label: _('Publicidad Punto'), // Section label
                            header: _('Publicidad Punto'), // Section header
                            body: {
                                rows: [
                                    {
                                        padding: 5,
                                        height: 50,
                                        cols: [
                                            { gravity: 6, minWidth: 170 }, // Column configuration
                                            {
                                                view: 'button', // Button to add advertising
                                                value: _('Añadir Publicidad'),
                                                type: 'form',
                                                hidden: !devConfig.getPermAction(
                                                    'permAdvertising',
                                                    'Add', // Permission check for adding advertising
                                                ),
                                                css: 'prm-permAdvertising',
                                                click: () => {
                                                    this.app.callEvent(
                                                        'addAdvertising:button', // Event to trigger on button click
                                                        [[]],
                                                    );
                                                },
                                            },
                                        ],
                                    },
                                    TableAdvertising, // Including TableAdvertising component
                                    toolbar, // Including toolbar
                                ],
                            },
                        },
                    ],
                },
            ],
        };

        // Returning the main configuration object
        return {
            type: 'wide',
            responsive: true,
            cols: [left], // Main layout with left panel
        };
    }
}

// FILE DOCUMENTED
